"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionSummary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const CompareBarChart_1 = __importDefault(require("../../custom/CompareBarChart"));
const sumTransactions = (transactions, direction) => {
    return transactions[direction].reduce((sum, txns) => {
        return sum + txns.quantity;
    }, 0);
};
const SummaryContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(2)};
  margin-top: ${theme_1.theme.spacing(4)};
`;
const TransactionSummary = ({ transactions, }) => {
    const fromTotal = sumTransactions(transactions, "from");
    const toTotal = sumTransactions(transactions, "to");
    const netTotal = fromTotal - toTotal;
    return ((0, jsx_runtime_1.jsx)(SummaryContainer, { children: (0, jsx_runtime_1.jsx)(CompareBarChart_1.default, { maxDigits: 0, unit: "tCO\u2082e", valueSeries: [
                {
                    title: "Transaction summary",
                    selectorLabel: "Transactions",
                    values: [
                        {
                            name: "Quantity Sent",
                            value: fromTotal,
                            color: theme_1.theme.colors.green,
                        },
                        {
                            name: "Quantity Received",
                            value: toTotal === 0 ? 0 : -toTotal,
                            color: theme_1.theme.colors.black,
                        },
                        {
                            name: "Net Total",
                            value: netTotal,
                            color: netTotal >= 0 ? theme_1.theme.colors.green : theme_1.theme.colors.black,
                        },
                    ],
                },
            ], details: "Quantity sent, quantity received, and net total" }) }));
};
exports.TransactionSummary = TransactionSummary;
